<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [value]="viewItem"
          [class.ng-invalid]="viewStatus.invalid"
          [class.ng-valid]="viewStatus.valid"
          [class.ng-touched]="viewStatus.touched"
          [disabled]="viewDisabled"
          [valuePrimitive]="false"
          [textField]="'name'"
          [valueField]="'vendor'"
          [defaultItem]="{ name: config?.placeholder }"
          [filterable]="true"
          (valueChange)="pickFromView($event)"
          (blur)="blurFromView()"
          search-ex
          [seSearchColumns]="['name']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
          [listHeight]="config?.options?.listHeight"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.name === config?.placeholder"
            >
              <div style="display: inline-flex">
                <div>
                  <span>{{ dataItem.name }}</span>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.name">
                <span class="job-name">{{ dataItem.name }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }
      @if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [value]="selectedItems"
          [disabled]="viewDisabled"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'name'"
          [valueField]="'vendor'"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="pickManyFromView($event)"
          (blur)="blurFromView()"
          search-ex
          [seSearchColumns]="['name']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
          [listHeight]="config?.options?.listHeight"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.name === config?.placeholder"
            >
              <div style="display: inline-flex">
                <div>
                  <span>{{ dataItem.name }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
